import React, { useEffect, useState } from "react";
import { UploadCloud, X } from "lucide-react";
import "./styles/ImageUpload.css";
import axiosInstance from "../axiosInterceptor";
import { Fancybox } from "@fancyapps/ui";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
  closestCenter,
} from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  rectSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import SortableImage from "./SortableImage";
const BaseURL = process.env.REACT_APP_API_BASE_URL;

const ImageUploadMultiple = ({
  id,
  label,
  value = [],
  onChange,
  error,
  touched,
  accept = "image/*",
}) => {
  const [previews, setPreviews] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
  if (!value || value.length === 0) {
    setPreviews([]);
    return;
  }

  const newPreviews = value.map((file) =>
    typeof file === "string" ? `${BaseURL}/${file}` : URL.createObjectURL(file)
  );

  setPreviews(newPreviews);

  return () => {
    newPreviews.forEach((url) => {
      if (url.startsWith("blob:")) URL.revokeObjectURL(url);
    });
  };
}, [JSON.stringify(value)]);

  const handleFiles = (files) => {
    const fileArray = Array.from(files);
    onChange([...value, ...fileArray]);
  };

  const handleRemove = async (index) => {
  const file = value[index];

  try {
    if (!(file instanceof File)) {
      await axiosInstance.delete("/status/deleteImages", {
        data: { path: file },
      });
    }
    onChange(value.filter((_, i) => i !== index));

  } catch (err) {
    console.error("Delete error:", err);
  }
};


useEffect(() => {
  Fancybox.bind("[data-fancybox='gallery']", {
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ["close"],
      },
    },
    Thumbs: false,
  });

  return () => {
    Fancybox.unbind("[data-fancybox='gallery']");
    Fancybox.close();
  };
}, [previews]);

const sensors = useSensors(
  useSensor(PointerSensor, {
    activationConstraint: {
      distance: 5,
    },
  })
);
const handleDragEnd = (event) => {
  const { active, over } = event;

  if (!over || active.id === over.id) return;

  const oldIndex = active.id;
  const newIndex = over.id;

  const reordered = arrayMove(value, oldIndex, newIndex);

  onChange(reordered);
};
  return (
    <div className="image-upload-wrapper">
      <label className="col-form-label">{label}</label>

      <div
        className={`upload-box ${isDragging ? "active" : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          handleFiles(e.dataTransfer.files);
        }}
      >
        <input
          id={id}
          name={id}
          type="file"
          accept={accept}
          multiple
          onChange={(e) => handleFiles(e.target.files)}
          className="file-input"
        />

        {previews.length === 0 ? (
          <div className="upload-content">
            <div className="icon-wrapper">
              <UploadCloud size={42} strokeWidth={1.5} color="#e4715f" />
            </div>
            <h6>
              Drag & Drop or <span>Browse</span>
            </h6>
            <small>PNG, JPG, WEBP (Max 2MB)</small>
          </div>
        ) : (
<DndContext
  sensors={sensors}
  collisionDetection={closestCenter}
  onDragEnd={handleDragEnd}
>
  <SortableContext
    items={value.map((_, index) => index)}
    strategy={rectSortingStrategy}
  >
    <div className="preview-inside-box">
      {previews.map((src, index) => (
        <SortableImage
          key={index}
          id={index}
          index={index}
          src={src}
          onRemove={handleRemove}
        />
      ))}
    </div>
  </SortableContext>
</DndContext>
        )}
      </div>

      {error && touched && (
        <small className="text-danger">{error}</small>
      )}
    </div>
  );
};

export default ImageUploadMultiple;